
import {  useQuery } from "react-query"
import DataService from '../../../../config/DataServices'
import StakeService from "../../../../config/StakeServices"

const { getRequest } = DataService()
const { getStakeRequest } = StakeService()


export const useBuyTokenHistory = ({page,size,search}) => {

    return useQuery({
        queryKey: ["buy-token-history", page,size,search],
        queryFn: () => {
            return getRequest(`user/ico/buyTokenHistory?page=${page}&size=${size}&search=${search}`)
        }
    })
}

export const useStakeDetails = () => {

    return useQuery({
        queryKey: ["stake-balance"],
        queryFn: () => {
            return getStakeRequest(`user/stake/stakeBalance`)
        }
    })
}

export const useStakeHistory = ({page, size ,search}) => {

    return useQuery({
        queryKey: ["stake-history",page,size , search],
        queryFn: () => {
            return getStakeRequest(`user/stake/stakeHistory?page=${page}&size=${size}&search=${search}`)
        }
    })
}

export const useSingleStakeHistory = ({ id }) => {

    return useQuery({
        queryKey: ["single-stake-history",  id],
        queryFn: () => {
            return getStakeRequest(`user/stake/singleStakeHistory?id=${id}`)
        }
    })
}



export const usePercentageHistory = ({page, size,searchText}) => {

    return useQuery({
        queryKey: ["percentage-history",page,size,searchText],
        queryFn: () => {
            return getStakeRequest(`user/auth/getAutoStakeHistory?page=${page}&size=${size}&search=${searchText}`)
        }
    })
}

export const useEliteClub = () => {

    return useQuery({
        queryKey: ["elite-club"],
        queryFn: () => {
            return getStakeRequest(`user/auth/elite-club`)
        }
    })
}


export const useTotalActiveStake = () => {

    return useQuery({
        queryKey: ["total-active"],
        queryFn: () => {
            return getStakeRequest(`user/stake/getTotalActiveStake`)
        }
    })
}